import { takeEvery, call, put, select } from 'redux-saga/effects';
import { apiGet, apiPost, apiPatchJson } from '../core/dapi';
import logger from '../core/logger';
import { getAccountById, buildDapiAccountObject, getSaveLocationUrl } from '../core/dapi/account';
import {
  accountReceived,
  accountReplaceSavedLocations,
  accountSaveLocation,
  loginFailed,
  accountError,
} from '../actions/login';
import { setUserInfo } from '../core/session';
import { analyticsTrackEvent } from '../core/analytics';
import {
  LOCATION_SAVE_AFTER_LOGIN,
  LOCATION_SAVE_BEFORE_LOGGED_IN,
  LOCATION_SAVE_TO_ACCOUNT,
  LOGIN,
  LOGIN_STATUS_ERROR,
  LOGIN_STATUS_SUCESS,
} from '../core/analytics/events';
import { setRuntimeVariable, showModal } from '../actions/runtime';
import { LOGIN_SIGN_UP_MODAL } from '../components/LoginSignUpModal';
import { RECEIVE_ACCOUNT_SUMMARY } from '../constants';
import { completeOnboardingStep } from '../ducks/onboarding';

export const FETCH_LOGIN_ACCOUNT = 'saga/FETCH_LOGIN_ACCOUNT';
export const ONOBARDING_UPDATE_ACCOUNT = 'sagas/ONOBARDING_UPDATE_ACCOUNT';
export const SAVE_LOCATION_ACCOUNT = 'saga/SAVE_LOCATION_ACCOUNT';

function* fetchLoginAccount({ accountId }) {
  try {
    const url = getAccountById(accountId);

    const loginAccountResponse = yield call(apiGet, url, {
      fullResponse: true,
    });
    setUserInfo(loginAccountResponse);
    analyticsTrackEvent(LOGIN, {
      ...loginAccountResponse,
      status: LOGIN_STATUS_SUCESS,
    });
    yield put(accountReceived(loginAccountResponse));
  } catch (e) {
    logger.warn(e);
    analyticsTrackEvent(LOGIN, { status: LOGIN_STATUS_ERROR });
    yield put(loginFailed(e));
  }
}

function* saveLocationToAccount({ locationId, accountId, save, isLoggedIn }) {
  try {
    if (!accountId || !isLoggedIn) {
      yield put(
        setRuntimeVariable({
          name: 'saveLocationAfterLoginSuccess',
          value: locationId,
        })
      );
      analyticsTrackEvent(LOCATION_SAVE_BEFORE_LOGGED_IN, { locationId });
      yield put(showModal(LOGIN_SIGN_UP_MODAL));
      return;
    }

    analyticsTrackEvent(LOCATION_SAVE_TO_ACCOUNT, {
      settingSaveTo: save,
      accountId,
      locationId,
    });

    yield put(accountSaveLocation(locationId, save));
    const url = getSaveLocationUrl(accountId);
    const newLocations = yield call(apiPost, url, {
      account_id: accountId,
      location_id: locationId,
      active: save,
    });

    yield put(accountReplaceSavedLocations(newLocations));
  } catch (e) {
    console.error(e);
  }
}

function* loginSaveLocationObserver({ payload }) {
  try {
    const locationId = yield select(state => state.runtime.saveLocationAfterLoginSuccess);
    if (!locationId) return;

    analyticsTrackEvent(LOCATION_SAVE_AFTER_LOGIN, { locationId });
    const accountId = payload.value.id;

    yield put(setRuntimeVariable({ name: 'saveLocationAfterLoginSuccess', value: null }));

    yield put({
      type: SAVE_LOCATION_ACCOUNT,
      locationId,
      accountId,
      save: true,
    });
  } catch (e) {
    console.error(e);
  }
}

function* onboardingUpdateAccount({ formValues, accountId, currentScreen }) {
  try {
    const url = getAccountById(accountId);
    const data = buildDapiAccountObject(formValues);
    const response = yield call(apiPatchJson, url, data);
    yield put(accountReceived(response));
    yield put(completeOnboardingStep(currentScreen));
  } catch (e) {
    logger.error(e.message);
    yield put(accountError(e));
  }
}

function* rootSaga() {
  yield takeEvery(RECEIVE_ACCOUNT_SUMMARY, loginSaveLocationObserver);
  yield takeEvery(FETCH_LOGIN_ACCOUNT, fetchLoginAccount);
  yield takeEvery(SAVE_LOCATION_ACCOUNT, saveLocationToAccount);
  yield takeEvery(ONOBARDING_UPDATE_ACCOUNT, onboardingUpdateAccount);
}

export { rootSaga as default };
